import { createSelector } from 'reselect';
import { PDF, CURRENT_AFFAIRS, VIDEO, MATERIAL, TEST_SERIES, COURSE_MATERIAL, LIBRARY_MATERIAL, ARTICLES } from './../constants/bookmarkConstants';

const allBookMarks = allBookMarks => allBookMarks?.response?.bookmarks;


export const bookmarksSelector = createSelector(
    allBookMarks,
    bookmarks => {
         const x = {
            content_id: 1,
            content_name: "test",
            content_url: "test",
            description: "description",
            id: 3,
            image_url: "url",
            screen_name: "screen name",
            title: null,
            type: "pdf",
         }   

         const data = {
            [PDF]: {
                ids: {},
                bookmarks: []
            },
            [CURRENT_AFFAIRS]: {
                ids: {},
                bookmarks: []
            },
            [ARTICLES]: {
                ids: {},
                bookmarks: []
            },
            [VIDEO]: {
                ids: {},
                bookmarks: []
            },
            [MATERIAL]: {
                ids: {},
                bookmarks: []
            } ,       
            [TEST_SERIES]: {
                ids: {},
                bookmarks: []
            },        
            [COURSE_MATERIAL]: {
                ids: {},
                bookmarks: []
            },       
            [LIBRARY_MATERIAL]: {
                ids: {},
                bookmarks: []
            },       
         }

         bookmarks && bookmarks.length > 0 && bookmarks.map(b => {
             let type = b.type;
             if(!data[type]) return;
             data[type] = {
                 ...data[type],
                 ids: {
                     ...data[type]['ids'], 
                     [b.content_id]: true
                },
                bookmarks: [...data[type]['bookmarks'], b]
             }
         })

         return data;
    }
);
